module.exports = __webpack_public_path__ + "img/collection-weddingRingsCrown.00a8090.webp";